import { FC } from 'react';
import { Form, Table, Typography } from 'antd';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { OfficeObservationSparePart } from '@/libs/fleet-api/services/types';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';

type VisitReportUnitForm = {
	lists: OfficeObservationSparePart<'payload'>[];
};

const FBDHVisitReportSparePart: FC = () => {
	const { officeObservation } = useFBDHVisitReportApprovalPage();
	const { warehouse } = officeObservation ?? {};
	const { form, fieldName } = useForm<VisitReportUnitForm>();

	return (
		<Form.Provider>
			<Typography.Title level={3}>Ketersediaan Sparepart</Typography.Title>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				initialValues={
					{
						lists: warehouse?.spareParts ?? [],
					} as VisitReportUnitForm
				}
				style={{ marginBottom: 30 }}
			>
				<Form.Item
					name={fieldName(['lists'])}
					noStyle
				/>
				<Form.Item shouldUpdate>
					{({ getFieldsValue }) => {
						const values = getFieldsValue() as VisitReportUnitForm;
						const dataSource =
							values?.lists?.map((list, key?) => {
								return { ...list, key };
							}) ?? [];

						return (
							<Table
								bordered
								pagination={false}
								dataSource={dataSource}
								columns={[
									{
										title: 'No',
										render: (_, __, index) => index + 1,
										width: 1,
										align: 'center',
									},
									{
										title: 'Nama Item',
										render: (_, record) => record.name ?? '-',
									},
									{
										title: 'Jumlah',
										render: (_, record) => record.quantity ?? '-',
									},
								]}
							/>
						);
					}}
				</Form.Item>
			</Form>
		</Form.Provider>
	);
};

export default FBDHVisitReportSparePart;
